import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Login.css"; // <-- Your Login.css file
import { handleError, handleSuccess } from "../Utils";

const Login = () => {
  const navigate = useNavigate();

  const [loginInfo, setLoginInfo] = useState({
    email: "",
    password: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLoginInfo({ ...loginInfo, [name]: value });
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    const { email, password } = loginInfo;

    if (!email || !password) {
      return handleError("Please fill all the fields");
    }

    try {
      const url = "https://api.horizon.co.zm/auth/login";
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(loginInfo),
      });

      const result = await response.json();

      // ✅ 'role' removed from destructuring
      // Your backend must also be updated to not send 'role'
      const { success, message, jwtToken, name } = result;

      if (success) {
        handleSuccess(message);
        localStorage.clear();
        localStorage.setItem("token", jwtToken);
        // ✅ 'role' removed from localStorage
        localStorage.setItem("user", JSON.stringify({ name }));

        setTimeout(() => {
          // ✅ Simplified navigation
          // We will let App.js redirect from "/admin" to the dashboard
          navigate("/admin");
        }, 1000);
      } else {
        handleError(result.message);
      }
    } catch (err) {
      handleError(err.message);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        {/* <img src={yourLogo} alt="Logo" className="logo" /> */}

        <h2>Login</h2>
        <form onSubmit={handleLogin}>
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              onChange={handleChange}
              type="email"
              name="email"
              placeholder="Enter your email"
              value={loginInfo.email}
              className="form-control"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              onChange={handleChange}
              type="password"
              name="password"
              placeholder="Enter your password"
              value={loginInfo.password}
              className="form-control"
            />
          </div>

          <button type="submit" className="login-btn">
            Login
          </button>

          <p className="signup-link">
            Don't have an account? <Link to="/signup">Sign Up</Link>
          </p>
        </form>
      </div>
      <ToastContainer />
    </div>
  );
};

export default Login;